import { render } from "./DashboardScreen.vue?vue&type=template&id=7787ba2e&scoped=true"
import script from "./DashboardScreen.vue?vue&type=script&lang=js"
export * from "./DashboardScreen.vue?vue&type=script&lang=js"

import "./DashboardScreen.vue?vue&type=style&index=0&id=7787ba2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7787ba2e"]])

export default __exports__